module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "p-day-one__own-head-of-loss--no-padding p-day-one__own-head-of-loss--no-top-border",
    attrs: {
      "colspan": "3"
    }
  }, [_c('table', {
    staticClass: "u-full-width"
  }, [_c('tr', [_c('td', {
    staticClass: "p-day-one__own-head-of-loss--no-border",
    attrs: {
      "width": "40%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "p-day-one__own-head-of-loss--no-top-bottom-border",
    attrs: {
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.amount),
      expression: "amount",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "p-day-one__own-head-of-loss--no-border",
    attrs: {
      "width": "20%"
    }
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Remove")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46646f6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/OwnHeadOfLoss.vue
// module id = 1669
// module chunks = 0